import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceDisplay } from './PriceDisplay';
import { EbookMockup } from './EbookMockup';
export function OfferRecap() {
  return <section className="bg-[#F5F5F5] py-16 px-4 md:py-24" data-id="element-179">
      <div className="max-w-[600px] mx-auto text-center" data-id="element-180">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-181">
          <div className="inline-block bg-[#FFF3D6] text-yellow-800 font-heading font-bold text-sm px-4 py-1.5 rounded-full mb-6" data-id="element-182">
            🔥 OFERTA SOLO POR HOY
          </div>

          <h2 className="font-heading font-bold text-2xl md:text-3xl text-gray-900 mb-8" data-id="element-183">
            TODO LO QUE <span className="text-[#00A86B]" data-id="element-184">RECIBÍS</span>{' '}
            COMPRANDO HOY:
          </h2>

          <div className="mb-8" data-id="element-185">
            <img loading="lazy" src="https://cdn.magicpatterns.com/uploads/jVq2V72HP1u1iRDiW1JtQu/Gemini_Generated_Image_3zg8463zg8463zg8.png" alt="Pack Keto Air Fryer completo - Recetario, Plan 14 Días, Untables Keto" className="w-full max-w-md mx-auto h-auto rounded-2xl shadow-[0_8px_30px_rgba(0,168,107,0.2)]" data-id="element-186" />
          </div>

          <div className="space-y-3 mb-8 text-left" data-id="element-187">
            <div className="bg-white p-4 rounded-xl border-2 border-[#00A86B] shadow-sm flex items-center justify-between gap-4" data-id="element-188">
              <div className="flex items-center gap-3" data-id="element-189">
                <span className="text-xl" data-id="element-190">📖</span>
                <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-191">
                  40 Recetas Keto en Air Fryer Para Principiantes
                </span>
              </div>
              <span className="text-red-500 line-through text-sm whitespace-nowrap" data-id="element-192">
                $35.000
              </span>
            </div>

            <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm flex items-center justify-between gap-4" data-id="element-193">
              <div className="flex items-center gap-3" data-id="element-194">
                <span className="text-xl" data-id="element-195">🎁</span>
                <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-196">
                  BONUS #1 — Plan Keto 14 Días
                </span>
              </div>
              <span className="text-red-500 line-through text-sm whitespace-nowrap" data-id="element-197">
                $19.000
              </span>
            </div>

            <div className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm flex items-center justify-between gap-4" data-id="element-198">
              <div className="flex items-center gap-3" data-id="element-199">
                <span className="text-xl" data-id="element-200">🎁</span>
                <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-201">
                  BONUS #2 — Untables Keto
                </span>
              </div>
              <span className="text-red-500 line-through text-sm whitespace-nowrap" data-id="element-202">
                $25.000
              </span>
            </div>
          </div>

          <div className="mb-6" data-id="element-203">
            <p className="text-gray-700 font-bold text-lg md:text-xl mb-2" data-id="element-204">
              Valor total:{' '}
              <span className="line-through text-red-500 text-xl md:text-2xl" data-id="element-205">
                $79.000
              </span>
            </p>
            <p className="font-heading font-bold text-xl text-gray-900 mb-1" data-id="element-206">
              HOY ES TUYO POR:
            </p>
            <PriceDisplay amount={14500} className="font-heading font-extrabold text-[48px] text-[#00A86B] leading-none" data-id="element-207" />
            <span className="text-[#00A86B] font-bold ml-2" data-id="element-208">ARS</span>
          </div>

          <div className="w-full mb-6" data-id="element-209">
            <CTAButton data-id="element-210">QUIERO TODO AHORA →</CTAButton>
          </div>

          <div className="flex justify-center gap-4 text-xs text-gray-600 font-medium" data-id="element-211">
            <div className="flex items-center gap-1" data-id="element-212">
              <ZapIcon className="w-3.5 h-3.5 text-[#00A86B]" data-id="element-213" />
              <span data-id="element-214">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-215">
              <LockIcon className="w-3.5 h-3.5 text-[#00A86B]" data-id="element-216" />
              <span data-id="element-217">Pago único</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-218">
              <SmartphoneIcon className="w-3.5 h-3.5 text-[#00A86B]" data-id="element-219" />
              <span data-id="element-220">Producto 100% digital</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}